import { Gender, MaritalStatus } from '@xendit/id-open-banking-ekyb-common/dist/enums/submission';
import { GenderMap, MaritalStatusMap } from 'helpers/utils/enumsNameMappings';
import { FormBuilderField } from 'types/form.type';

export const Form3Section2Fields: FormBuilderField[] = [
  {
    name: 'surat_kuasa.authorised_signatories[0].name',
    label: 'Nama Lengkap (menurut dokumen identitas)',
    type: 'text',
    placeholder: 'Nama',
    fullWidth: true,
    validation: {
      required: 'Nama Lengkap harus diisi'
    }
  },
  {
    name: `surat_kuasa.authorised_signatories[0].gender`,
    label: 'Jenis Kelamin',
    type: 'radio',
    fullWidth: true,
    options: Object.keys(Gender).map((item) => {
      return { label: GenderMap[item as Gender], value: item, key: item };
    }),
    validation: {
      required: 'Jenis Kelamin harus diisi'
    }
  },
  {
    name: `surat_kuasa.authorised_signatories[0].marital_status`,
    label: 'Status Pernikahan',
    type: 'radio',
    fullWidth: true,
    options: Object.keys(MaritalStatus).map((item) => {
      return { label: MaritalStatusMap[item as MaritalStatus], value: item, key: item };
    }),
    validation: {
      required: 'Status Pernikahan harus diisi'
    }
  },
  {
    name: 'surat_kuasa.authorised_signatories[0].mobile_number',
    label: 'Nomor Handphone',
    placeholder: '0000',
    type: 'phonenumber',
    validation: {
      required: 'Nomor Handphone harus diisi',
      validate: {
        isEmpty: (value) => !!value.slice(3) || 'Nomor Handphone harus diisi',
        isNumber: (value) => !isNaN(Number(value)) || 'Pastikan format nomor sesuai',
        isPositive: (value) => Number(value) > 0 || 'Pastikan format nomor sesuai'
      }
    }
  },
  {
    name: 'surat_kuasa.authorised_signatories[0].email_address',
    label: 'Alamat Email',
    type: 'text',
    placeholder: 'Alamat Email',
    validation: {
      required: 'Alamat Email harus diisi',
      pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        message: 'Berikan alamat email yang valid'
      }
    }
  },
  {
    name: 'surat_kuasa.authorised_signatories[0].profession',
    label: 'Pekerjaan',
    type: 'text',
    placeholder: 'Pekerjaan',
    validation: {
      required: 'Pekerjaan harus diisi'
    }
  },
  {
    name: 'surat_kuasa.authorised_signatories[0].relationship',
    label: 'Hubungan dengan perusahaan',
    type: 'text',
    placeholder: 'Hubungan',
    validation: {
      required: 'Hubungan harus diisi'
    }
  },
  {
    name: 'surat_kuasa.authorised_signatories[0].identity_document_id',
    type: 'file',
    label: 'Dokumen Identitas',
    validation: {
      required: 'Dokumen Identitas harus diisi'
    }
  },
  {
    type: 'divider'
  }
];
